<template>
    <div>
        <kt-panel>
            <kt-panel-body>
                <form @submit.prevent="edit">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-row>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="id">
                                            {{ $t('label.settlement_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="id"
                                                name="id"
                                                disabled
                                                :value="form_data.id"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.user_full_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="full_name"
                                                name="full_name"
                                                disabled
                                                :value="form_data.full_name"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_farsi_name">
                                            {{ $t('label.gateway_farsi_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="gateway_farsi_name"
                                                name="gateway_farsi_name"
                                                disabled
                                                :value="form_data.gateway_farsi_name"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_id">
                                            {{ $t('label.gateway_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="gateway_id"
                                                name="gateway_id"
                                                disabled
                                                :value="form_data.gateway_id"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-row lg="6" md="6" xs="12">
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="amount">
                                            {{ $t('label.settlement_amount') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="amount"
                                                name="amount"
                                                disabled
                                                :value="form_data.amount"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="wage">
                                            {{ $t('label.wage') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="wage"
                                                name="wage"
                                                disabled
                                                :value="form_data.wage"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="wage">
                                            {{ $t('label.banking_wage') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="wage"
                                                name="wage"
                                                disabled
                                                :value="form_data.banking_wage"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-row lg="12" md="12" xs="12">
                                <kt-col lg="12" md="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="description">
                                            {{ $t('label.description') }}
                                        </kt-form-label>
                                        <textarea
                                                id="description"
                                                name="description"
                                                class="form-control"
                                                rows="2"
                                                v-model="form_data.description"
                                        >
                                </textarea>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-row lg="12" md="12" xs="12">
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="created_at">
                                            {{ $t('label.date_created') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="created_at"
                                                name="created_at"
                                                disabled
                                                :value="form_data.created_at"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="updated_at">
                                            {{ $t('label.date_updated') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="updated_at"
                                                name="updated_at"
                                                disabled
                                                :value="form_data.updated_at"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="tracking_code">
                                            {{ $t('label.tracking_code') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="tracking_code"
                                                name="tracking_code"
                                                v-model="form_data.tracking_code"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" xs="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('label.change_status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" name="status" v-model="form_data.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.id"
                                                    :selected="form_data.value"
                                            >
                                                {{ status.str }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-col>
                    </kt-row>
                    <kt-row lg="12" md="12" xs="12">

                        <kt-col lg="3" md="3">
                            <kt-form-group>
                                <kt-form-label for="website_address">
                                    {{ $t('label.website_address') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="website_address"
                                        name="website_address"
                                        dir="ltr"
                                        disabled
                                        :value="form_data.website_address"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="3" xs="12">
                            <kt-form-group>
                                <kt-form-label for="sheba_number">
                                    {{ $t('label.sheba_number') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="sheba_number"
                                        name="sheba_number"
                                        disabled
                                        :value="form_data.sheba_number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="3" xs="12">
                            <div style="margin-top: 25px" v-if="form_data.next_id != 0" class="position-absolute">
                                <a
                                        class="btn btn-md btn-info btn-wide"
                                        @click="change_location(form_data.next_id)"
                                        style="color: #fff!important; cursor: pointer"
                                >
                                    <i class="fa fa-arrow-right" aria-hidden="true"></i> {{ $t('label.next') }}
                                </a>
                            </div>
                            <kt-form-action style="text-align: end;margin-top: 25px">
                                <button class="btn btn-md btn-success btn-wide" type="submit" id="save_btn">
                                    {{ $t('btn.update') }}
                                </button>
                            </kt-form-action>
                        </kt-col>
                    </kt-row>
                </form>
            </kt-panel-body>
        </kt-panel>
    </div>

</template>

<script>
    import $ from 'jquery'
    import {KTApp} from '@/plugins/core/app'
    import {settlementService} from '@/common/api.service'
    import {i18n} from '@/plugins/i18n'

    export default {
        props: {
            form_data: {
                required: true,
            }
        },
        data() {
            return {
                statuses: [
                    {
                        id: 0,
                        value: this.$t('settlement.status.pending')
                    },
                    {
                        id: 2,
                        value: this.$t('settlement.status.accepted')
                    },
                    {
                        id: 3,
                        value: this.$t('settlement.status.rejected')
                    }
                ],
            }
        },
        methods: {
            edit(e) {
                let btn = $('#save_btn')
                let form = $('#settings_form')
                KTApp.progress(btn)

                let params = {
                    status: this.form_data.status,
                    tracking_code: this.form_data.tracking_code,
                    description: this.form_data.description,
                }

                settlementService.updateSettlement(this.form_data.id, params)
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                    })
                    .finally(
                        response => {
                            this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                            KTApp.unprogress(btn)
                        }
                    )
            },
            change_location(id) {
                window.location.assign('../' + id + '/details')
            }
        },
    }
</script>

<style>

</style>